import { type FC, useContext } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

export const LoginRegistrationRegistrationFormFirstNameInput: FC = () => {
  const intl = useIntl()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  return (
    <FormControl
      error={!model.validator.isPropertyValid('firstName')}
      required
      value={model.firstName}
    >
      <FormLabel htmlFor="registerForm-firstName">
        {intl.formatMessage({ id: 'general.label.firstName' })}
      </FormLabel>
      <Input
        {...registrationFormState.makeInputProps('firstName', {
          validateOnBlur: true,
        })}
        id="registerForm-firstName"
        slotProps={{
          input: { 'data-qa-id': 'register-form-firstName' },
        }}
      />
      {model.validator.getFirstErrorFor('firstName') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('firstName')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
